<template>
  <div>
    <el-tabs class="tab tabCon" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部" name="first">
        <div class="conBor">
          <el-table :data="tutorialData.data" stripe style="width: 100%">
            <el-table-column fixed prop="signExam" label="编号"></el-table-column>
            <el-table-column prop="tutorialName" label="辅导课"></el-table-column>
            <el-table-column  label="辅导教室"></el-table-column>
            <el-table-column  prop="seatNumber" label="座位"></el-table-column>
            <el-table-column  prop="principal" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系电话"></el-table-column>
          </el-table>
        </div>
        <div class="block">
          <el-pagination
            @current-change="pageChange"
            :page-size="params.pageSize"
            layout="prev, pager, next, jumper"
            :total="tutorialData.totalCount"
          ></el-pagination>
        </div>
        <PayDialog :signId="paySignId" :visible="payVisible" @payCancel="payCancel" @payDone="payDone"></PayDialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

export default {
  data() {
    return {
      payVisible:false,
      paySignId:'',
      activeName: "first",
      tutorialData: {
        totalCount:0,
        data:[]
      },
      params:{
        pageNo:1,
        pageSize:10,
        typeId: null,
        status:1,
      }
    };
  },
  created() {
    console.log(localStorage.getItem("token"));
    this.tutorialList();
  },
  methods: {
    toPay(signId){
      let that =this;
      that.paySignId = signId;
      that.payVisible = true;
    },
    payCancel(){
      let that = this;
      that.payVisible = false;
      that.tutorialList();
    },
    payDone(){
      let that = this;
      that.payVisible = false;
      that.tutorialList();
    },
    pageChange(page){
      console.log('page',page)
      let that =this;
      that.params.pageNo =page;
      that.getList();
    },
    handleClick(tab, event) {
      console.log(11)
      this.typeId = event.index;
      if (event.index == 0) {
        this.typeId = null;
      }
      console.log(this.typeId);
      that.params.pageNo = 1;
      this.tutorialList();
    },
    tutorialList() {
      console.log(11);
      let me = this;
      window.Global.get("/tutorial/userInfo", me.params, rs => {
        console.log(rs.data.result);
        if (rs.data.success) {
          console.log(rs.data.result,11);
          me.tutorialData.data = rs.data.result;
        } else {
        }
      });
    }
  }
};
</script>

<style lang="less">
@import "../../static/less/tutorial.less";
</style>



// WEBPACK FOOTER //
// src/components/Tutorial.vue